/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Flex,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import Loader from "../../../components/PageLoader";
import BreadCrumb from "../../../components/breadCrumb";
import { Paths } from "../../../routes/paths";
import {
  useAddCustomer,
  useGetCustomerSlaDefaults,
  useGetCustomerSlaDefaultsEmpty,
} from "../../../services/customer-api";
import {
  useLookupCurrency,
  useLookupDesignations,
} from "../../../services/lookups-queries";
import { emptyCustomer } from "../constants";
// import Insurance from "./insurance";
import Contracts from "./contracts";
// import ReplenishmentModels from "./replenishment-models";
// import ContactPerson from "./contact-persons";
// import Accounts from "./accounts";
import CustomerInformation from "./customer-information";
// import OfferedServices from "./offered-services";
// import EscalationGroups from "./escalation-groups";
import LastCallTime from "./last-call-time";
import CustomerServiceAccessTiming from "./customer-service-access-timing";
import Summary from "./summary";
import LocationInitials from "./locationInitial";

const steps = [
  { title: "Information" },
  // { title: "Accounts" },
  // { title: "Contacts" },
  // { title: "Insurance" },
  // { title: "Models" },
  { title: "Contracts" },
  // { title: "Offered Services" },
  // { title: "Escalations" },
  { title: "Last Call Time" },
  { title: "Service Access Timing" },
  { title: "Location Initials" },
];

export default function AddCustomer() {
  const [triggerValidation, setTriggerValidation] = useState(false);
  const [designationList, setDesignationList] = useState([]);
  const [customer, setCustomer] = useState({ ...emptyCustomer });
  const [slaDefaults, setSlaDefaults] = useState(null);
  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });
  const navigate = useNavigate();

  const {
    mutate: getSlaDefaults,
    isPending: gettingSlaDefaults,
    data: slaDefaultsRes,
  } = useGetCustomerSlaDefaultsEmpty();

  useEffect(() => {
    getSlaDefaults();
  }, []);

  const { data: currencyListRes, isPending: gettingCurrencyList } =
    useLookupCurrency();
  // const { data: countries, isPending: gettingCountryList, error: countryError } = useLookupCountries();

  const { data: designations, isPending: gettingDesignations } =
    useLookupDesignations();
  const {
    mutate: createRequest,
    isSuccess: isRequestCreated,
    isPending: creatingRequest,
  } = useAddCustomer();

  useEffect(() => {
    if (slaDefaultsRes?.data) {
      setSlaDefaults(slaDefaultsRes.data);
    }
  }, [slaDefaultsRes]);

  useEffect(() => {
    if (isRequestCreated) {
      navigate(Paths.customers);
      return;
    }

    if (designations?.data) {
      setDesignationList(
        designations.data.map((des) => ({
          value: des.description,
          label: des.description,
        })),
      );
    }
  }, [isRequestCreated, designations]);

  const updateCustomerInfo = (information) => {
    const _customer = {
      ...customer,
      clientId: information.clientId,
      name: information.name,
      shortName: information.shortName,
      customerType: information.customerType,
      customerCode: information.customerCode,
      status: information.status,
      hasSeparateDispenseCount: information.hasSeparateDispenseCount,
      requiresEVhr: information.requiresEVhr,
      requestedBy: information.requestedBy,
      comments: information.comments,
    };
    setCustomer(_customer);
  };

  const getCustomerInformation = useMemo(
    () => ({
      clientId: customer.clientId,
      name: customer.name,
      shortName: customer.shortName,
      customerType: customer.customerType,
      customerCode: customer.customerCode,
      status: "",
      hasSeparateDispenseCount: customer.hasSeparateDispenseCount,
      requiresEVhr: customer.requiresEVhr,
      requestedBy: customer.requestedBy,
      comments: customer.comments,
    }),
    [customer],
  );

  // const updateAccounts = (accounts) => {
  //   const _customer = {
  //     ...customer,
  //     accounts,
  //   };
  //   setCustomer(_customer);
  // };

  // const getAccounts = useMemo(() => [...customer.accounts], [customer]);

  // const updateContactPersons = (contactPersons) => {
  //   const _customer = {
  //     ...customer,
  //     contactPersons,
  //   };
  //   setCustomer(_customer);
  // };

  // const getContactPersons = useMemo(
  //   () => [...customer.contactPersons],
  //   [customer],
  // );

  // const updateReplenishmentModels = (replenishmentModels) => {
  //   const _customer = {
  //     ...customer,
  //     replenishmentModels,
  //   };
  //   setCustomer(_customer);
  // };

  // const getReplenishmentModels = useMemo(
  //   () =>
  //     customer.replenishmentModels.map((elm) => ({ ...elm, expanded: false })),
  //   [customer],
  // );

  // const updateInsuranceLimits = (insuranceLimits) => {
  //   const _customer = {
  //     ...customer,
  //     insuranceLimits,
  //   };
  //   setCustomer(_customer);
  // };

  // const getInsuranceLimits = useMemo(
  //   () => [...customer.insuranceLimits],
  //   [customer],
  // );
  const updateContracts = (contracts) => {
    const _customer = {
      ...customer,
      contracts,
    };
    setCustomer(_customer);
  };

  const getContracts = useMemo(() => [...customer.contracts], [customer]);

  // const getOfferedServices = useMemo(
  //   () => [...customer.offeredServices],
  //   [customer],
  // );
  // const updateServices = (services) => {
  //   const _customer = {
  //     ...customer,
  //     offeredServices: services,
  //   };
  //   setCustomer(_customer);
  // };
  // const getEscalationGroups = useMemo(
  //   () => [...customer.escalationGroups],
  //   [customer],
  // );
  // const updateEscalationGroup = (escalationGroups) => {
  //   const _customer = {
  //     ...customer,
  //     escalationGroups,
  //   };
  //   setCustomer(_customer);
  // };
  const getLastCallTime = useMemo(
    () =>
      Array.isArray(customer.lastCallTimings)
        ? [...customer.lastCallTimings]
        : [],
    [customer.lastCallTimings],
  );
  const updateLastCallTime = (lastCallTime) => {
    const _customer = {
      ...customer,
      lastCallTimings: lastCallTime,
    };
    setCustomer(_customer);
  };

  const getCustomerServiceAccessTiming = useMemo(
    () => [...customer.serviceWindows],
    [customer],
  );

  const updateCustomerServiceAccessTiming = (serviceWindows) => {
    const _customer = {
      ...customer,
      serviceWindows,
    };
    setCustomer(_customer);
  };

  const updateLocationInitials = (locationInitials) => {
    const _customer = {
      ...customer,
      locationInitials,
    };
    setCustomer(_customer);
  };

  const {
    handleSubmit,
    control,
    trigger,
    watch,
    resetField,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: { ...getCustomerInformation },
  });
  useEffect(() => {
    if (activeStep === 1 && triggerValidation) {
      trigger();
    } else if (activeStep !== 1 && triggerValidation) {
      setTriggerValidation(false);
    }
  }, [triggerValidation, activeStep]);
  return (
    <>
      {creatingRequest ||
      gettingCurrencyList ||
      gettingDesignations ||
      gettingSlaDefaults ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Customers", link: Paths.customers },
            { text: "Create Customer", isCurrentPage: true },
          ]}
        />

        <Stepper index={activeStep} size="sm" className="extra-small-stepper">
          {steps.map((step, index) => (
            <Step
              key={index}
              onClick={() => {
                // if (activeStep === 1) {
                //   updateCustomerInfo(getValues());
                // }
                if (activeStep > 1) {
                  setActiveStep(index + 1);
                }
              }}
            >
              <StepIndicator style={{ cursor: "pointer" }}>
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={<StepNumber />}
                  active={<StepNumber />}
                />
              </StepIndicator>

              <div style={{ cursor: "pointer" }}>
                <StepTitle>{step.title}</StepTitle>
                <StepDescription>{step.description}</StepDescription>
              </div>

              <StepSeparator />
            </Step>
          ))}
        </Stepper>

        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div className="add-location-form">
                {activeStep === 1 ? (
                  <form>
                    <CustomerInformation
                      // customerObject={getCustomerInformation}
                      onNextStep={() => {
                        setActiveStep(2);
                        updateCustomerInfo(getValues());
                      }}
                      handleSubmit={handleSubmit}
                      control={control}
                      errors={errors}
                      watch={watch}
                      resetField={resetField}
                      isValid={isValid}
                    />
                  </form>
                ) : activeStep === 2 ? (
                  <Contracts
                    contracts={getContracts}
                    currencies={currencyListRes?.data || []}
                    slaDefaults={slaDefaults}
                    onPrevStep={(contracts) => {
                      setActiveStep(1);
                      updateContracts(contracts);
                    }}
                    onNextStep={(contracts) => {
                      setActiveStep(3);
                      updateContracts(contracts);
                    }}
                    addData={(data) => {
                      updateContracts(data);
                    }}
                  />
                ) : activeStep === 3 ? (
                  <LastCallTime
                    control={control}
                    errors={errors}
                    watch={watch}
                    resetField={resetField}
                    lastCallTime={getLastCallTime}
                    slaDefaults={slaDefaults}
                    onPrevStep={(lastCallTime) => {
                      setActiveStep(2);
                      updateLastCallTime(lastCallTime);
                    }}
                    onNextStep={(lastCallTime) => {
                      setActiveStep(4);
                      updateLastCallTime(lastCallTime);
                    }}
                  />
                ) : activeStep === 4 ? (
                  <CustomerServiceAccessTiming
                    customerServiceAccessTiming={getCustomerServiceAccessTiming}
                    slaDefaults={slaDefaults}
                    onPrevStep={(serviceAccessTiming) => {
                      updateCustomerServiceAccessTiming(serviceAccessTiming);
                      setActiveStep(3);
                    }}
                    onNextStep={(serviceAccessTiming) => {
                      updateCustomerServiceAccessTiming(serviceAccessTiming);

                      if (isValid) {
                        setActiveStep(5);
                      } else {
                        setActiveStep(1);
                        setTriggerValidation(true);
                      }
                    }}
                    addData={(data) => {
                      updateCustomerServiceAccessTiming(data);
                    }}
                  />
                ) : activeStep === 5 ? (
                  <LocationInitials
                    addedLocations={customer.locationInitials}
                    isValid={customer?.locationInitials?.length}
                    onAddLocations={updateLocationInitials}
                    onPrevStep={() => {
                      setActiveStep(4);
                    }}
                    onNextStep={() => {
                      setActiveStep(6);
                    }}
                  />
                ) : activeStep === 6 ? (
                  <Summary
                    customer={customer}
                    onPrevStep={() => {
                      setActiveStep(5);
                    }}
                    onCreateCustomer={(customerPayload) => {
                      createRequest({ ...customerPayload });
                    }}
                  />
                ) : (
                  <></>
                )}

                {/* <Flex
                    w={"100%"}
                    justify={"flex-end"}
                    flexDirection={"row"}
                    onClick={() => {
                      if (activeStep < 6) {
                        setActiveStep(activeStep + 1);
                      }
                    }}
                  >
                    <Button type={activeStep === 6 ? "submit" : ""}>{activeStep === 6 ? "Submit" : "Next"}</Button>
                  </Flex> */}
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
